import CourseRegisterButton from "../../components/CourseRegisterButton";

// eslint-disable-next-line react/jsx-props-no-spreading
const EventPopoverButton = (props) => <CourseRegisterButton {...props} />;

export default EventPopoverButton;
